import Login from "../components/organisms/Login"

const LoginPage = () => {

  return <Login />
  
}

export default LoginPage